import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { QuestionDetailContent } from "./question-detail-content";

interface QuestionDetailSheetProps {
  questionId: string | null;
  solutionId: string;
  onOpenChange: (open: boolean) => void;
}

export function QuestionDetailSheet({
  questionId,
  solutionId,
  onOpenChange,
}: QuestionDetailSheetProps) {
  const isOpen = questionId !== null;

  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full sm:max-w-[640px] overflow-y-auto p-0">
        <SheetHeader className="sr-only">
          <SheetTitle>Question detail</SheetTitle>
          <SheetDescription>Question detail</SheetDescription>
        </SheetHeader>
        <QuestionDetailContent
          questionId={questionId}
          solutionId={solutionId}
          onDeleted={() => onOpenChange(false)}
        />
      </SheetContent>
    </Sheet>
  );
}
